(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  // After a post the page reloads at the form: move focus to the result so screen readers hear it.
  const focusResult = () => {
    const el = document.querySelector('.tc-contact__success, .tc-contact__errors');
    if (el) el.focus();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusResult);
  else focusResult();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cosmic-spotlight"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var ball = e.target.closest('[data-cosmic-ball]');
  if (!ball) return;
  var stage = ball.closest('.cosmic');
  if (!stage || stage.classList.contains('is-party')) return;
  stage.classList.add('is-party');
  setTimeout(function () { stage.classList.remove('is-party'); }, 6000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dealer-inquiry"] && !Shopify.designMode) return;
  try {
    
(() => {
  // After a post the page reloads at the form: move focus to the result so screen readers hear it.
  const focusResult = () => {
    const el = document.querySelector('.tc-dealer__success, .tc-dealer__errors');
    if (el) el.focus();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusResult);
  else focusResult();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-burst"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('tc-hero')) return;
  class TcHero extends HTMLElement {
    connectedCallback() {
      const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!fine || reduce || !document.body.classList.contains('motion')) return;
      this.onMove = (e) => {
        const r = this.getBoundingClientRect();
        const x = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width - 0.5) * 2));
        const y = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height - 0.5) * 2));
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.style.setProperty('--mx', x.toFixed(3));
          this.style.setProperty('--my', y.toFixed(3));
        });
      };
      this.onLeave = () => {
        cancelAnimationFrame(this.frame);
        this.style.setProperty('--mx', '0');
        this.style.setProperty('--my', '0');
      };
      this.addEventListener('pointermove', this.onMove, { passive: true });
      this.addEventListener('pointerleave', this.onLeave);
    }
    disconnectedCallback() {
      if (!this.onMove) return;
      this.removeEventListener('pointermove', this.onMove);
      this.removeEventListener('pointerleave', this.onLeave);
    }
  }
  customElements.define('tc-hero', TcHero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(() => {
  const ROOT = '[data-section-root="main-cart"]';
  const cartUrl = () => (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
  let io;

  // Mobile checkout bar: visible while the main Check out button is still below the fold.
  const bindBar = () => {
    if (io) io.disconnect();
    const root = document.querySelector(ROOT);
    const bar = root && root.querySelector('[data-cart-bar]');
    const main = root && root.querySelector('[data-main-checkout]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top > 0);
    });
    io.observe(main);
  };

  // Enter in a quantity field updates the line instead of submitting the whole form.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' || !e.target.closest) return;
    const input = e.target.closest('.tc-cart input[data-line]');
    if (!input) return;
    e.preventDefault();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Save the order note as the shopper types so a re-render keeps it.
  let noteTimer;
  document.addEventListener('input', (e) => {
    const note = e.target.closest && e.target.closest('.tc-cart [data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => {
      fetch(`${cartUrl()}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note.value }) }).catch(() => {});
    }, 400);
  });

  // theme.js swaps the whole cart root after a quantity change or removal, which drops keyboard focus
  // onto <body>. Remember the control in use so the same control (or the next line, or the heading)
  // gets focus back once the new markup is in.
  let lastFocus = null;
  document.addEventListener('focusin', (e) => {
    const t = e.target;
    if (!t.closest || !t.closest(ROOT)) { lastFocus = null; return; }
    let key = null;
    if (t.matches('[data-remove-line]')) key = 'remove';
    else if (t.matches('button[name="plus"], button[name="minus"]')) key = `button[name="${t.name}"]`;
    else if (t.matches('input[data-line]')) key = 'input[data-line]';
    const line = t.closest('.tc-line');
    lastFocus = { line: line ? line.id : null, key, at: Date.now() };
  });
  const restoreFocus = () => {
    const f = lastFocus;
    const active = document.activeElement;
    if (!f || Date.now() - f.at > 15000) return;
    if (active && active !== document.body && document.contains(active)) return;
    const root = document.querySelector(ROOT);
    if (!root) return;
    const line = f.line ? root.querySelector(`#${f.line}`) : null;
    let target = null;
    if (line && f.key === 'remove') target = line.querySelector('.tc-line__title');
    else if (line && f.key) target = line.querySelector(f.key);
    if (target) target.focus();
    else root.querySelector('#CartTitle')?.focus({ preventScroll: true });
    lastFocus = null;
  };

  // Keep the page in step when the cart changes elsewhere (drawer, quick add).
  document.addEventListener('cart:updated', async (e) => {
    const cart = e.detail && e.detail.cart;
    const wrap = document.querySelector('.tc-cart');
    if (!cart || !wrap) return;
    wrap.classList.toggle('is-empty', cart.item_count === 0);
    const root = document.querySelector(ROOT);
    if (root && root.dataset.cartSig !== `${cart.item_count}:${cart.total_price}`) {
      try {
        const html = await (await fetch(`${cartUrl()}?section_id=main-cart`)).text();
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector(ROOT);
        const current = document.querySelector(ROOT);
        if (next && current) current.replaceWith(next);
      } catch (err) { /* keep the current markup */ }
    }
    bindBar();
    restoreFocus();
    // Express buttons are web components that set themselves up when re-inserted; the legacy
    // payment button script needs a nudge instead.
    const pb = window.Shopify && window.Shopify.PaymentButton;
    if (pb && typeof pb.init === 'function' && document.querySelector(`${ROOT} .tc-sum__express`)) {
      try { pb.init(); } catch (err) { /* buttons stay as rendered */ }
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindBar);
  else bindBar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('tc-ticker')) return;
  class TcTicker extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('.tk__toggle');
      if (!button || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      button.hidden = false;
      button.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
      });
    }
  }
  customElements.define('tc-ticker', TcTicker);
})();

  } catch(e) { console.error(e); }
})();
})();
